// extracted by mini-css-extract-plugin
export default {"dimensions":"GlobalOptions_dimensions__fqSi9","cross":"GlobalOptions_cross__F0Jig","formGroup":"GlobalOptions_formGroup__mi85x"};